// extracted by mini-css-extract-plugin
export default {"container":"pdp-free-services__container___1DJm9","services":"pdp-free-services__services___23tGZ"};